<template>
  <div class="text-center">
    <v-dialog
        v-model="dialogResult.show"
        v-on:click:outside="toggleDialogResult({...dialogResult, show: false})"
        v-on:close="toggleDialogResult({...dialogResult, show: false})"
        width="500"
    >
      <v-card>

        <v-alert
            :type="dialogResult.type"
        >

          {{dialogResult.message}}

        </v-alert>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
export default {
  name: "ResultDialog",
  data: ()=>({

  }),
  mounted() {
    console.log('OPEN MY MODAL')
  },
  computed: {
    ...mapState('Bayartempo',['dialogResult'])
  },
  methods: {

    ...mapActions('Bayartempo',['toggleDialogResult']),

  }
}
</script>

<style scoped>

</style>